<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "BusinessUnitIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
